interface MainLayoutProps {
  children?: React.ReactNode;
  isLoading?: boolean;
}

export const MainLayout = ({ children, isLoading }: MainLayoutProps) => {
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 to-black flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black">
      <main>
        {children}
      </main>
    </div>
  );
};